export default __webpack_public_path__ + "static/mask-layer-quote-1692e6a0e20904b046680936969ca6a3.png";